import * as React from 'react';
import Notifications from '../components/Notifications';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import { DateRangePicker } from '@progress/kendo-react-dateinputs';

const Visitors = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    if (permissions && !permissions.CanView) navigate("/error401");
    if (localStorage.getItem("userid") === null) navigate("/logout");
    const [dateRange, setDateRange] = React.useState();
    const [lookupParams, setLookupParams] = React.useState("");

    let dt = new Date();
    let dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: null};

    React.useEffect(() => {
        GetColumnDefs("Visitors", setColumns, setErrorMessage);
        GetPermissions(["ViewTransaction", "NewTransaction", "EditTransaction", "DeleteTransaction", "ReportTransaction"], setPermissions);
        setDateRange(dr);
        updateParams(dr);
    }, [])

    const rangeChanged = (event) => {
        let dr = event.target.value;
        setDateRange(event.target.value);
        updateParams(dr);
    }

    const updateParams = (dr) => {
        var param = {
            FromDate: dr.start === null ? "2000-01-01T00:00:00Z" : dr.start.toISOString(),
            ToDate: dr.end === null ? "2050-01-01T00:00:00Z" : dr.end.toISOString(),
        }
        setLookupParams(encodeURI(JSON.stringify(param)));
    }

    return (
        <div>
            <Notifications errorMessage={errorMessage} />
            <div className="row" style={{ padding: "5px 10px" }}>
                <div className="col-md-3">
                    <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged}
                        startDateInputSettings={{ label: "Date - Start" }}
                        endDateInputSettings={{ label: "Date - End" }}
                    />
                </div>
            </div>

            {columns && permissions && <DataGrid dataSource='apiv7/visitors' columns={columns} permissions={permissions} params={lookupParams} keyField="visitorId" />}
        </div>
    );
}

export default Visitors;